import { useTranslation } from 'react-i18next';
import HeadingIcon from '@assets/icons/mail.svg?react';
import SwitzerlandLogo from '@assets/icons/switzerland.png';

export const Contact = () => {
    const { t } = useTranslation();

    return (
        <section
            id="contact"
            className="w-full py-8 md:py-12 bg-sectbg2"
        >
            <div className="max-w-[1280px] mx-auto px-8">
                {/* Grid: 1 column on mobile/tablet, 3 columns on desktop */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                    {/* Column 1: Heading */}
                    <div className="lg:col-span-1">
                        <h2 className="text-4xl font-bold text-secttxthead tracking-tight flex items-center gap-x-4">
                            <HeadingIcon className="h-9 w-auto" />
                            <span>{t('nav.contact')}</span>
                        </h2>
                    </div>

                    {/* Column 2: Content (spans 2 of 3 columns on desktop) */}
                    <div className="lg:col-span-2">
                        <p className="text-xl text-secttxtprim">
                            {t('contact.intro')}
                        </p>


                        <address className="text-xl font-normal text-secttxtprim not-italic mt-6 space-y-1">
                            <p className="font-bold">{t('contact.company')}</p>
                            <p>{t('contact.street')}</p>
                            <p>{t('contact.city')}</p>
                            <div className="flex items-center justify center gap-2">
                                <p>{t('contact.country')}</p>
                                <img src={SwitzerlandLogo} className="h-5 w-auto" />
                            </div>
                            <p>
                                <a href="mailto:info@baseunit.ch" className="link link-hover">
                                    info@baseunit.ch
                                </a>
                            </p>
                        </address>
                    </div>
                </div>
            </div>
        </section>
    );
};